var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoostFlyers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_1",
    "data-name": 1,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 52.9 61.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #000;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.76,59.36v-4.89h5.34c1,0,1.81-.81,1.81-1.81V1.81c0-1-.81-1.81-1.81-1.81H9.65c-1.38,0-2.51,1.12-2.51,2.5v4.19H2.51c-1.38,0-2.51,1.12-2.51,2.5v50.16c0,1,.81,1.81,1.81,1.81h42.15c.99,0,1.8-.81,1.8-1.81ZM10.11,2.97h39.83v48.54h-4.18V8.5c0-1-.81-1.81-1.8-1.81H10.11v-3.73ZM42.79,58.2H2.97V9.66h39.83v48.54Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.9,27.62c1.34,0,2.43-1.09,2.43-2.43v-7.89c0-1.34-1.09-2.43-2.43-2.43h-9.62c-1.34,0-2.43,1.09-2.43,2.43v7.89c0,1.34,1.09,2.43,2.43,2.43h9.62ZM9.82,17.85h8.54v6.81h-8.54v-6.81Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.53,16.45h-9.09c-1.91,0-1.91,2.97,0,2.97h9.09c1.91,0,1.91-2.97,0-2.97Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.53,24.93h-9.09c-1.91,0-1.91,2.97,0,2.97h9.09c1.91,0,1.91-2.97,0-2.97Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.53,33.41H9.72c-1.91,0-1.91,2.97,0,2.97h26.81c1.91,0,1.91-2.97,0-2.97Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.53,41.89H9.72c-1.91,0-1.91,2.97,0,2.97h26.81c1.91,0,1.91-2.97,0-2.97Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.53,50.36H9.72c-1.91,0-1.91,2.97,0,2.97h26.81c1.91,0,1.91-2.97,0-2.97Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoostFlyers);
export default __webpack_public_path__ + "static/media/boost-flyers.990a30ff097f7892a97f70304cda892f.svg";
export { ForwardRef as ReactComponent };